<template>
	
	<div class="sidebar-menu">
		<ul>
			<li :key="menuItem.id" v-for="menuItem in sidebarMenu">
                <a :href="menuItem.linkURL">{{ menuItem.linkText }}</a>
            </li>
		</ul>
	</div>
	
</template>

<script>
	
	export default {
		name: 'SidebarMenu',
		
		props: ['sidebarMenu']
	}
	
</script>